// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2xgas","title":"card_title__3caEb","inActive":"card_inActive__2X1I8"};